export const SEARCH_CONSTANT = {
  SEARCH_BY_PHONE_OR_NAME: "/voter/search/v1/search",
  ADD: "/visitor",
  UPDATE: "/visitor",
};
export const PAGE_CONFIG = {
  GENERIC_SEARCH_LIST: "/assets/page-configs/generic-list.json",
};
export const SEARCH_BY_AADHAR = {
  SEARCH_BY_PHONE_OR_AADHAR_OR_NAME: "/visitor/search",
  QUICK_SEARCH: "/voter/search/quickSearch"
};

